// A deleted church is kept for a recovery window before it is purged. These
// mirror the rules in shared/components/RestoreOrganizationGate (used by the
// desktop apps), kept here so this app doesn't pull that component and the
// shared UI kit it draws with into the bundle. Change both together.

export const RECOVERY_WINDOW_DAYS = 30;

/**
 * True when the church is soft-deleted: `isActive === false` or `deletedAt`
 * set. The backend sets both on delete and clears both on restore; either one
 * alone still counts, so a half-updated record can't slip through.
 */
export const isChurchSoftDeleted = (church: { isActive?: boolean; deletedAt?: string | null } | null | undefined): boolean =>
  !!church && (church.isActive === false || !!church.deletedAt);

/** When a soft-deleted church will be purged for good, or null without a valid `deletedAt`. */
export const getPurgeDate = (deletedAt: string | null | undefined, recoveryWindowDays: number = RECOVERY_WINDOW_DAYS): Date | null => {
  if (!deletedAt) return null;
  const parsed = new Date(deletedAt);
  if (Number.isNaN(parsed.getTime())) return null;
  const purge = new Date(parsed);
  purge.setUTCDate(purge.getUTCDate() + recoveryWindowDays);
  return purge;
};
